// aws-config.js
const awsConfig = {
  // Global AWS Region
  region: 'us-east-1',
  
  // Authentication configuration
  Auth: {
    // Cognito User Pool
    userPoolId: 'us-east-1_dYzOfr4lu',
    userPoolWebClientId: '343gs9r7jk2dqs3pe6indh83nr',
    mandatorySignIn: true,
    authenticationFlowType: 'USER_SRP_AUTH',
    // Ensure tokens are stored securely
    cookieStorage: {
      domain: 'portal.utilityauditpro.com',
      secure: true,
      path: '/',
      expires: 365,
    }
  },
  
  // API Gateway configuration
  API: {
    endpoints: [
      {
        name: 'UtilityAuditProAPI',
        endpoint: 'https://rax7v0bghk.execute-api.us-east-1.amazonaws.com/prod', // Use direct API Gateway URL
        region: 'us-east-1',
        custom_header: async () => {
          // Add custom authorization header to each request
          try {
            const session = await import('aws-amplify/auth').then(
              module => module.fetchAuthSession()
            );
            return {
              Authorization: `Bearer ${session.tokens.accessToken.toString()}`
            };
          } catch (error) {
            console.error('Error generating custom auth header:', error);
            return {};
          }
        }
      }
    ]
  },
  
  // Storage configuration for S3 (for file uploads)
  Storage: {
    AWSS3: {
      bucket: 'utilityauditpro-bills-575108946999-prod', // Update to the bills bucket
      region: 'us-east-1',
      serverSideEncryption: 'AES256' // Enable server-side encryption
    }
  }
};

export default awsConfig;